import SummaryCard from 'components/Content/BeautyInsider/BeautyInsiderSummary/SummaryCard/SummaryCard';

export default SummaryCard;
